/**
 * Exposes filters for formatting
 */
import { formatCarat, formatMoney } from "../lib";
var FormattersMixin = {
  filters: {
    carats: function (carat) {
      return formatCarat(carat);
    },
    money: function (amount) {
      return `$${formatMoney(amount)}`;
    },
  },
  methods: {
    formatCarats: function (carat) {
      return formatCarat(carat);
    },
  },
};
export default FormattersMixin;
